module.exports = __webpack_public_path__ + "img/preview-lg.5af7e4b1.png";